import moment from "moment";
import { compose } from "redux";
import range from "lodash/range";
import times from "lodash/times";
import isEmpty from "lodash/isEmpty";
import debounce from "lodash/debounce";
import { connect } from "react-redux";
import React, { PureComponent } from "react";
import { Grid, MenuItem } from "@material-ui/core";
import { Field, reduxForm } from "redux-form/immutable";

import {
  WORK_SCHEDULE_REPORT_FORM,
  WORK_SCHEDULE_REPORT_TYPE,
} from "features/planner/report/report.constants";

import {
  downloadScheduleReport,
  workScheduleReportFormOnChange,
} from "features/planner/report/report.actions";

import LoadingButton from "app/components/LoadingButton";
import FilterDropdownMenu from "app/components/FilterDropdownMenu";
import SearchFieldField from "app/components/form/SearchFieldField";
import { getEmployeeGroupsByIdFromState } from "features/planner/planner.selectors";
import { workScheduleReportTypeToString } from "features/planner/report/report.mappers";

const WorkScheduleReportTypeField = ({ input }) => {
  const { value, onChange } = input;

  return (
    <FilterDropdownMenu
      label="Report"
      value={workScheduleReportTypeToString(value) || "..."}
    >
      {Object.values(WORK_SCHEDULE_REPORT_TYPE).map(type => (
        <MenuItem
          key={type}
          selected={type === value}
          onClick={() => onChange(type)}
        >
          {workScheduleReportTypeToString(type)}
        </MenuItem>
      ))}
    </FilterDropdownMenu>
  );
};

const WorkScheduleReportYearField = ({ input }) => {
  const { value, onChange } = input;

  return (
    <FilterDropdownMenu label="Year" value={value || "..."}>
      {range(-15, 15).map(index => (
        <MenuItem
          key={index}
          selected={value === value + index}
          onClick={() => onChange(value + index)}
        >
          {value + index}
        </MenuItem>
      ))}
    </FilterDropdownMenu>
  );
};

const WorkScheduleReportMonthField = ({ input }) => {
  const { value, onChange } = input;

  return (
    <FilterDropdownMenu label="Month" value={moment.months(value)}>
      {moment.months().map((month, index) => (
        <MenuItem
          key={month}
          selected={index === value}
          onClick={() => onChange(index)}
        >
          {month}
        </MenuItem>
      ))}
    </FilterDropdownMenu>
  );
};

const WorkScheduleReportGroupField = ({ input, employeeGroups }) => {
  const { value, onChange } = input;

  return (
    <FilterDropdownMenu
      label="Group"
      value={employeeGroups.getIn([value, "name"], "Show all")}
    >
      <MenuItem selected={isEmpty(value)} onClick={() => onChange(null)}>
        Show all
      </MenuItem>
      {employeeGroups.keySeq().map(employeeGroupId => (
        <MenuItem
          selected={value === employeeGroupId}
          key={employeeGroupId}
          onClick={() => onChange(employeeGroupId)}
        >
          {employeeGroups.getIn([employeeGroupId, "name"])}
        </MenuItem>
      ))}
    </FilterDropdownMenu>
  );
};

class WorkScheduleReportForm extends PureComponent {
  render() {
    const { submitting, handleSubmit, reportType, employeeGroups } = this.props;

    return (
      <>
        <Grid item />
        <Grid item>
          <Field
            name={WORK_SCHEDULE_REPORT_FORM.SEARCH}
            component={SearchFieldField}
            TextFieldProps={{
              autoFocus: true,
              fullWidth: true,
              placeholder: "Find employee",
            }}
          />
        </Grid>
        <Grid item>
          <Field
            employeeGroups={employeeGroups}
            component={WorkScheduleReportGroupField}
            name={WORK_SCHEDULE_REPORT_FORM.EMPLOYEE_GROUP_ID}
          />
        </Grid>
        {times(3, index => (
          <Grid item key={index} />
        ))}
        <Grid item>
          <Field
            name={WORK_SCHEDULE_REPORT_FORM.TYPE}
            component={WorkScheduleReportTypeField}
          />
        </Grid>
        <Grid item>
          <Field
            name={WORK_SCHEDULE_REPORT_FORM.YEAR}
            component={WorkScheduleReportYearField}
          />
        </Grid>
        {reportType === WORK_SCHEDULE_REPORT_TYPE.MONTH && (
          <Grid item>
            <Field
              name={WORK_SCHEDULE_REPORT_FORM.MONTH}
              component={WorkScheduleReportMonthField}
            />
          </Grid>
        )}
        <Grid item xs />
        <Grid item>
          <LoadingButton
            size="medium"
            type="submit"
            variant="contained"
            loading={submitting}
            disabled={submitting}
            onClick={handleSubmit}
          >
            Download
          </LoadingButton>
        </Grid>
      </>
    );
  }
}

export default compose(
  connect(
    state => ({
      employeeGroups: getEmployeeGroupsByIdFromState(state),
    }),
    {
      onSubmit: downloadScheduleReport,
    },
  ),
  reduxForm({
    destroyOnUnmount: false,
    form: WORK_SCHEDULE_REPORT_FORM.ID,
    onChange: debounce(workScheduleReportFormOnChange, 300),
  }),
)(WorkScheduleReportForm);
